import React, { useState } from 'react';
import { Stack, TextInput, PasswordInput, Button, Alert } from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconAlertCircle } from '@tabler/icons-react';
import { auth } from '../../firebase';
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { ensureUserProfile } from '../../services/auth/UserProfileService';

export default function EmailSignUpForm({ onSuccess }) {
  const [error, setError] = useState('');
  const form = useForm({
    initialValues: { name: '', email: '', password: '', confirmPassword: '' },
    validate: {
      name: (v) => (v.trim().length >= 2 ? null : 'Name must be at least 2 characters'),
      email: (v) => (/^\S+@\S+$/.test(v) ? null : 'Invalid email'),
      password: (v) => (v.length >= 6 ? null : 'Password must be at least 6 characters'),
      confirmPassword: (v, values) => (v === values.password ? null : 'Passwords do not match'),
    },
  });

  const handleSubmit = async (values) => {
    setError('');
    try {
      const cred = await createUserWithEmailAndPassword(auth, values.email, values.password);
      await updateProfile(cred.user, { displayName: values.name });
      await ensureUserProfile({ ...cred.user, displayName: values.name });
      onSuccess?.();
    } catch (e) {
      setError('Sign-up failed');
    }
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack>
        {error && (
          <Alert icon={<IconAlertCircle size={16} />} title="Sign-up error" color="red">
            {error}
          </Alert>
        )}
        <TextInput required label="Name" placeholder="Your name" {...form.getInputProps('name')} />
        <TextInput required label="Email" placeholder="you@example.com" {...form.getInputProps('email')} />
        <PasswordInput required label="Password" placeholder="At least 6 characters" {...form.getInputProps('password')} />
        <PasswordInput required label="Confirm password" placeholder="Repeat your password" {...form.getInputProps('confirmPassword')} />
        <Button type="submit">Create account</Button>
      </Stack>
    </form>
  );
}

